<template>
	<div class="watch-pills-manage">
		<input-date-picker @input="onControlDatePickerInput" v-if="isRouteByDate"/>
		<spinner v-if="pills.loading"/>
		<div v-if="pills.data.length" class="idi-table pills">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.type') }}</div>
				<div class="idi-cell">{{ $t('labels.general.name') }}</div>
				<div class="idi-cell">{{ $t('labels.general.start') }}</div>
				<div class="idi-cell">{{ $t('labels.general.end') }}</div>
				<div class="idi-cell">{{ $t('labels.general.hour') }}</div>
				<div class="idi-cell">{{ $t('labels.general.week') }}</div>
				<div class="idi-cell">{{ $t('labels.general.dose') }}</div>
				<div class="idi-cell"></div>
			</div>
			<div class="idi-row" v-for="pill in pills.data" :key="pill.id">
				<div class="idi-cell grid-area-type">
					<shape :src="svgSrc(pill.type)" :class="svgClass(pill.color)" class="pill-svg"/>
				</div>
				<div class="idi-cell grid-area-name">
					<span class="label mobile">{{ $t('labels.general.name') }}</span>
					<span>{{ pill.name }}</span>
				</div>
				<div class="idi-cell grid-area-start">
					<span class="label mobile">{{ $t('labels.general.start') }}</span>
					<span>{{ pill.date_start }}</span>
				</div>
				<div class="idi-cell grid-area-end">
					<span class="label mobile">{{ $t('labels.general.end') }}</span>
					<span>{{ pill.date_end }}</span>
				</div>
				<div class="idi-cell grid-area-hour">
					<span class="label mobile">{{ $t('labels.general.hour') }}</span>
					<span>{{ pill.hour | formatHour }}</span>
				</div>
				<div class="idi-cell grid-area-week days-of-week">
					<span>
						<span v-for="day in daysOfWeek" :key="day.value" :class="weekDayClass(day, pill.week)" class="day">{{ day.text }}</span>
					</span>
				</div>
				<div class="idi-cell grid-area-dose">
					<span class="label mobile">{{ $t('labels.general.dose') }}</span>
					<span>{{ pill.dose }}</span>
				</div>
				<div class="idi-cell grid-area-operations">
					<div>
						<button-icon :to="{ name: 'WatchPillsManagePillEdit', params: { pill_id: pill.id, data: pill } }" icon="edit" title="Edit" class="btn-edit"/>
						<button-icon-loading :loading="deleting.has(pill.id)" @click.native="deletePill(pill.id)" icon="trash" title="Delete" class="btn-delete"/>
					</div>
				</div>
			</div>
		</div>
		<p v-if="!pills.loading && !pills.data.length" class="no-results">{{ $t('base.general.no_results') }}</p>
		<router-view/>
	</div>
</template>

<script>
import clamp from '@/utils/clamp'
import Pill from '@/classes/Pill'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			pills: {
				loading: false,
				error: null,
				data: []
			},
			deleting: new Set()
		}
	},
	computed: {
		colors () {
			return Pill.colors()
		},
		daysOfWeek () {
			return [
				{ text: this.$t('labels.week.mon'), value: 1  },
				{ text: this.$t('labels.week.tue'), value: 2  },
				{ text: this.$t('labels.week.wed'), value: 4  },
				{ text: this.$t('labels.week.thu'), value: 8  },
				{ text: this.$t('labels.week.fri'), value: 16 },
				{ text: this.$t('labels.week.sat'), value: 32 },
				{ text: this.$t('labels.week.sun'), value: 64 }
			]
		},
		isRouteByDate () {
			return this.$route.name === 'WatchPillsManageByDate'
		}
	},
	watch: {
		'$route' (to, from) {
			this.getPills()
		}
	},
	methods: {
		svgSrc (shape) {
			return `/static/svg/pills/${this.numToShape(shape)}.svg`
		},
		svgClass (color) {
			return `color-${this.numToColor(color)}`
		},
		weekDayClass (day, value) {
			return day.value & value ? 'take' : ''
		},
		numToShape (n) {
			return `shape${n.toString().padStart(2, 0)}`
		},
		numToColor (n) {
			n = clamp(parseInt(n), 0, this.colors.length - 1)
			return this.colors[n]
		},
		getPills () {
			switch (this.$route.name) {
				case 'WatchPillsManageByDate':
					const day = this.$moment().format('YYYY-MM-DD')
					this.getPillsByDay(day)
					break
				case 'WatchPillsManageActives':
					this.getPillsActive()
					break
				case 'WatchPillsManageAll':
					this.getPillsAll()
					break
				//default:
				//	this.getPillsAll()
			}
		},
		getPillsAll () {
			this.pills.loading = true
			this.pills.data = []
			this.$api.pillbox2.getAll(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch pillbox', 'pillbox.getAll OK', response)()
				this.pills.data = Pill.processResponse(response.body)
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.getAll ERROR', error)()
				this.pills.error = error
			}).finally(() => {
				this.pills.loading = false
			})
		},
		getPillsActive () {
			this.pills.loading = true
			this.pills.data = []
			this.$api.pillbox2.getActive(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch pillbox', 'pillbox.getActive OK', response)()
				this.pills.data = Pill.processResponse(response.body)
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.getActive ERROR', error)()
				this.pills.error = error
			}).finally(() => {
				this.pills.loading = false
			})
		},
		getPillsByDay (day) {
			this.pills.loading = true
			this.pills.data = []
			this.$api.pillbox2.getByDay(this, this.user_uid, this.watch_id, day).then(response => {
				this.$log.info('watch pillbox', 'pillbox.getByDay OK', response)()
				this.pills.data = Pill.processResponse(response.body)
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.getByDay ERROR', error)()
				this.pills.error = error
			}).finally(() => {
				this.pills.loading = false
			})
		},
		deletePill (id) {
			if (confirm('Delete?')) {
				this.deleting.add(id)
				this.$forceUpdate()
				this.$api.pillbox2.delete(this, this.user_uid, this.watch_id, id).then(response => {
					this.$log.info('watch pillbox', 'pillbox.delete OK', response)()
				}).catch(error => {
					this.$log.error('watch pillbox', 'pillbox.delete ERROR', error)()
					this.pills.error = error
				}).finally(() => {
					this.deleting.delete(id)
					this.getPills()
				})
			}
		},
		onControlDatePickerInput (date) {
			this.getPillsByDay(date)
		}
	},
	mounted () {
		this.getPills()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/pillboxV2/PillsManage.vue